// /* global gettext */

export const HSPLITTER = Math.min(650, $(window).width() / 2); // position of splitter without aggregate
export const WSPLITTER = $(window).height() / 2; // position of splitter without aggregate

export const DEFAULT_MODE = 'explore';
export const DEFAULT_DRILL = 'agent_time@ymdh:hour';
export const DEFAULT_FILTERS = []; //
export const DEFAULT_STAT_LIMIT = 5000;
export const DEFAULT_FEEDBACK_URL = '';

export const DEFAULT_MEASURES = {
  'call_duration_sum': gettext('Время разговора'),
  'activity_time_sum': gettext('Время активности'),
  'record_count': gettext('Количество событий'),
  'file_size_sum': gettext('Размер файла'),
};

export const IS_IE_BROWSER = (function() {
  const uAgent = window.navigator.userAgent;
  return (!!uAgent.match(/Trident.*rv\:11\./) || !!uAgent.match(/MSIE/));
}());

export const USE_CACHE = true;
export const HARD_LIMIT = 100;
export const DEFAULT_FILTER_LIMIT = 50;
export const PATH_STRING_SEPARATOR = 'ʻ'; // inverted comma

export const CONDITIONS_META = {
  '=': {
    name: '=',
    label: gettext('Равно'),
    controlType: 'value',
  },
  '!': {
    name: '!',
    label: gettext('Не равно'),
    controlType: 'value',
  },
  '^': {
    name: '^',
    label: gettext('Содержит'),
    controlType: 'text',
  },
  '!^': {
    name: '!^',
    label: gettext('Не содержит'),
    controlType: 'text',
  },
  '@': {
    name: '@',
    label: gettext('С учетом морфологии'),
    controlType: 'text',
  },
  'R': {
    name: 'R',
    label: gettext('Регулярное выражение'),
    controlType: 'text',
  },
  '>': {
    name: '>',
    label: gettext('Позднее'),
    controlType: 'number',
  },
  '<': {
    name: '<',
    label: gettext('Ранее'),
    controlType: 'number',
  },
};



// WEBPACK FOOTER //
// ./src/common/config.js